exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.text-span-2{font-size:1.25rem;color:#363636;text-shadow:1px 1px 1px rgb(0 0 0/25%)}", ""]);

// exports
